<template>
  <!-- メニュー無し版 -->
  <v-app id="inspire">
    <v-app-bar
      app
      flat
      dark
      color="brack"
    >
      <router-link to="/" style="text-decoration: none; color: #FFFFFF;" class="d-none d-md-block">
        <v-img v-if="!$vuetify.breakpoint.xs" src="../assets/logo.png" max-width="36" max-height="47" class="mr-3"></v-img>
      </router-link>
      <router-link to="/" style="text-decoration: none; color: #FFFFFF;">
        <v-toolbar-title class="logo d-none d-md-block">{{$t("message.header.title.app")}}</v-toolbar-title>
        <v-toolbar-title class="logo d-block d-md-none" style="font-size: 1.5rem">{{$t("message.header.title.app")}}</v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <MpLang />
      <MpLogout class="ml-1"/>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <MpFooter />
  </v-app>
</template>

<script>
import MpFooter from '@/components/parts/MpFooter.vue'
import MpLang from '@/components/parts/MpLang.vue'
import MpLogout from '@/components/parts/MpLogout.vue'

export default {
  components: {
    MpFooter,
    MpLang,
    MpLogout
  },
  props: {
    source: String
  },
  data: () => ({}),
  created () {
    this.$vuetify.theme.dark = false
  }
}
</script>

<style>
div.v-toolbar__title {
  font-size: 2.0rem;
}
</style>
